<footer>
  <div class="block-content">
    <div class="px-4 relative z-5">
      <div class="py-2 flex flex-column sm:flex-row sm:align-items-center sm:justify-content-between text-center sm:text-left">

        <!-- Texto -->
        <div class="mt-2 line-height-3 mb-2 sm:mb-0">
          <p class="text-xs md:text-sm text-600">
            © 2025 - Conselho Nacional de Justiça | Todos os direitos reservados | Version: {{ version }}
          </p>
        </div>

        <!-- Logo -->
        <div class="flex justify-content-center sm:justify-content-end">
          <p-image
            src="../../../assets/imagem/rodape.png"
            alt="Logo CNJ"
            width="100"
            class="mr-0 sm:mr-2"
          ></p-image>
        </div>

      </div>
    </div>
  </div>
</footer>
